import type { Cell, Network, Project } from "./types";
import { COLS, emptyRow } from "./types";

const uid = (p: string) => `${p}_${Math.random().toString(36).slice(2, 9)}`;

const c = (type: Cell["type"], operand = "", extra: Partial<Cell> = {}): Cell => ({
  type,
  operand,
  ...extra,
});

function motorNetwork(): Network {
  const rows = [emptyRow(), emptyRow()];
  rows[0]![0] = c("NO", "I0.0");
  rows[0]![1] = c("NO", "I0.1"); // STOP سلك NC فيعطي 1 عند عدم الضغط
  rows[0]![4] = c("COIL", "Q0.0");
  rows[1]![0] = c("NO", "Q0.0");
  const links = Array.from({ length: 1 }, () =>
    Array.from({ length: COLS + 1 }, (_, i) => i === 1),
  );
  return {
    id: uid("net"),
    title: "Network 1 — تشغيل/إيقاف مع تثبيت ذاتي",
    comment: "زر START على I0.0، زر STOP على I0.1، الكونتكتر على Q0.0",
    rows,
    links,
  };
}

function lampNetwork(): Network {
  const rows = [emptyRow()];
  rows[0]![0] = c("NO", "Q0.0");
  rows[0]![4] = c("COIL", "Q0.1");
  return {
    id: uid("net"),
    title: "Network 2 — لمبة بيان التشغيل",
    comment: "",
    rows,
    links: [],
  };
}

export function blankProject(name = "مشروع جديد"): Project {
  return {
    id: uid("prj"),
    name,
    devices: [],
    wires: [],
    networks: [motorNetwork()],
    scanMs: 30,
    updatedAt: Date.now(),
  };
}

export function demoProject(): Project {
  const psu = { id: "psu1", type: "psu24", x: 60, y: 60, label: "24VDC", state: {}, props: {} };
  const plc = { id: "plc1", type: "plc", x: 380, y: 300, label: "S7-1200", state: {}, props: {} };
  const start = {
    id: "pb1",
    type: "pb_start",
    x: 80,
    y: 260,
    label: "START",
    state: {},
    props: {},
  };
  const stop = { id: "pb2", type: "pb_stop", x: 210, y: 260, label: "STOP", state: {}, props: {} };
  const km = {
    id: "km1",
    type: "contactor",
    x: 1140,
    y: 300,
    label: "KM1",
    state: {},
    props: {},
  };
  const motor = { id: "m1", type: "motor", x: 1140, y: 560, label: "M1", state: {}, props: {} };
  const lamp = { id: "hl1", type: "lamp", x: 900, y: 800, label: "HL1", state: {}, props: {} };
  const src380 = {
    id: "s380",
    type: "src380",
    x: 1140,
    y: 80,
    label: "380VAC",
    state: {},
    props: {},
  };

  const w = (from: string, to: string, color: string) => ({ id: uid("w"), from, to, color });

  return {
    id: uid("prj"),
    name: "مثال: تشغيل ماطور",
    devices: [psu, plc, start, stop, km, motor, lamp, src380],
    wires: [
      // input side
      w("psu1:+V", "pb1:13", "red"),
      w("pb1:14", "plc1:I0.0", "blue"),
      w("psu1:+V", "pb2:11", "red"),
      w("pb2:12", "plc1:I0.1", "blue"),
      w("psu1:-V", "plc1:1M", "black"),
      w("psu1:+V", "plc1:L+", "red"),
      w("psu1:-V", "plc1:M", "black"),
      // output side
      w("psu1:+V", "plc1:3L+", "red"),
      w("psu1:-V", "plc1:3M", "black"),
      w("plc1:Q0.0", "km1:A1", "red"),
      w("km1:A2", "psu1:-V", "black"),
      w("plc1:Q0.1", "hl1:X1", "red"),
      w("hl1:X2", "psu1:-V", "black"),
      // power circuit
      w("s380:L1", "km1:1/L1", "black"),
      w("s380:L2", "km1:3/L2", "black"),
      w("s380:L3", "km1:5/L3", "black"),
      w("km1:2/T1", "m1:U", "black"),
      w("km1:4/T2", "m1:V", "black"),
      w("km1:6/T3", "m1:W", "black"),
    ],
    networks: [motorNetwork(), lampNetwork()],
    scanMs: 30,
    updatedAt: Date.now(),
  };
}
